//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('valuta', {
//        templateUrl: 'views/components/views/valuta/valuta.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'valutaService', 'logisticService', 'economyService', 'layoutService', function ($stateParams, stateService, utilityService, valutaService, logisticService, economyService, layoutService) {
//            const vm = this;
//            let valutaId = $stateParams.valuta_id;
            
//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                valutaId: valutaId,
//                bgValuta: {
//                    selected: 'BASIC',
//                    buttons: [
//                        { id: 'BASIC', label: 'valuta_basic', color: 'primary', onClick: function () { vm.model.bgValuta.selected = 'BASIC'; } },
//                        { id: 'OTHER', label: 'valuta_other', color: 'primary', onClick: function () { vm.model.bgValuta.selected = 'OTHER'; } }
//                    ]
//                },
//                edit: {},
//                selectListCountries: [],
//                selectListRoundOff: []
//            };
            
//            async function loadValutaEdit() {
//                vm.model.edit = (await valutaService.getValutaEdit({ valuta_id: valutaId }))[0];
//            }

//            async function loadCountries() {
//                vm.model.selectListCountries = await logisticService.listCountries();
//            }

//            async function loadRoundOff() {
//                vm.model.selectListRoundOff = await economyService.listRoundOff();
//            }

//            function recalcValuta() {
//                vm.model.edit.valuta_exchangefactor = (utilityService.parseNumber(vm.model.edit.valuta_exchangerate) / utilityService.parseNumber(vm.model.edit.valuta_pr));
//            }

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'valuta_exchangerate':
//                    case 'valuta_pr':
//                        if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

//                        vm.model.edit[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

//                        recalcValuta();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            vm.selectBgValuta = function (item) {
//                vm.model.bgValuta.selected = item;
//            };

//            vm.saveChanges = function () {
//                valutaService.saveObj(vm.model.edit).then(function () {
//                    stateService.back();
//                });
//            };

//            vm.$onInit = function () {
//                loadValutaEdit();
//                loadCountries();
//                loadRoundOff();
//            }
//        }]
//    });
//})();
